import Typing from 'app/components/Typing';
import BaseChatItem from 'app/modules/virtual-assistant/components/chat-items/BaseChatItem';
import { useEffect, useRef } from 'react';

import { useConcierge } from '../hooks/useConcierge';
import useUnreadMessageCount from '../hooks/useUnreadMessageCount';

const MessageTypingAnimation = () => {
  const avatarURL = useConcierge()?.avatar;
  const count = useUnreadMessageCount();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (count === 0) {
      ref.current?.scrollIntoView({ block: 'end' });
    }
  }, [count]);

  return (
    <div ref={ref}>
      <BaseChatItem
        showAvatar
        avatarURL={avatarURL}
        isUserMessage={false}
        hideMessageOwnership
      >
        <Typing />
      </BaseChatItem>
    </div>
  );
};

export default MessageTypingAnimation;
